import _ from 'lodash'

export default class Invoice {
  id = null
  dateTo = null
  dateFrom = null
  state = null
  title = null

  constructor (data) {
    _.forEach(data, (value, field) => {
      if (this.hasOwnProperty(field)) {
        this[field] = value
      }
    })
  }
}
